import DetailSeriesSeasons from './DetailSeriesSeasons'

export default DetailSeriesSeasons
// eslint-disable-next-line import/export
export * from './DetailSeriesSeasons'
